import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export interface TextProps {
  /**
   * Apply any tailwind class customizations here.
   */
  className?: string
  /**
   * Apply any inline styles to the root node.
   */
  style?: React.CSSProperties
}

export interface BodyProps extends TextProps {
  /**
   * Overwrite the default margins applied to the body text.
   */
  marginClassNames?: string
}

const BODY_STYLES =
  'font-body text-sm font-normal text-body [&_a]:text-primary [&_a]:underline'
const MARGIN_STYLES = 'my-2'

export const Body: React.FC<PropsWithChildren<BodyProps>> = ({
  className,
  children,
  marginClassNames,
  style,
}) => (
  <p
    className={concatStyles(
      BODY_STYLES,
      marginClassNames ? marginClassNames : MARGIN_STYLES,
      className
    )}
    style={style}
  >
    {children}
  </p>
)

export const Text: React.FC<PropsWithChildren<TextProps>> = ({
  className,
  children,
  style,
}) => (
  <span className={concatStyles(BODY_STYLES, className)} style={style}>
    {children}
  </span>
)
